import { render, staticRenderFns } from "./SocialForm.vue?vue&type=template&id=46941ea0&scoped=true"
import script from "./SocialForm.vue?vue&type=script&lang=js"
export * from "./SocialForm.vue?vue&type=script&lang=js"
import style0 from "./SocialForm.vue?vue&type=style&index=0&id=46941ea0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46941ea0",
  null
  
)

export default component.exports